/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIamRolePermissionRequest
 */
export interface GetIamRolePermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof GetIamRolePermissionRequest
     */
    iamRolePermissionId: string;
}

export function GetIamRolePermissionRequestFromJSON(json: any): GetIamRolePermissionRequest {
    return GetIamRolePermissionRequestFromJSONTyped(json, false);
}

export function GetIamRolePermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamRolePermissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRolePermissionId': json['iam_role_permission_id'],
    };
}

export function GetIamRolePermissionRequestToJSON(value?: GetIamRolePermissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_role_permission_id': value.iamRolePermissionId,
    };
}


